import { utcToZonedTime } from 'date-fns-tz';

import { timezoneMap } from '@swf/account';

import { customTimezoneMap } from './customTimezoneMap';

export const getCustomTimezoneOffsetById = (timezone: number | undefined): number => {
  const timezoneData = customTimezoneMap.find(
    (tzm: { id: number; offset: number }) => tzm.id === timezone
  );
  return timezoneData ? timezoneData.offset : 0;
};

export const getTimezoneNameById = (timezone: number | undefined): string => {
  const normalisedTimezoneMap: { id: number; canonicalName: string }[] = Object.values(timezoneMap);
  const timezoneData = normalisedTimezoneMap.find(
    (tzm: { id: number; canonicalName: string }) => tzm.id === timezone
  );
  return timezoneData ? timezoneData.canonicalName : '';
};

const shiftZonedTime = (date = new Date(), timezone: string) => {
  const zonedTime = utcToZonedTime(date.toISOString(), timezone);
  const hour = zonedTime.getHours().toString();
  const minute = zonedTime.getMinutes().toString();
  const day = zonedTime.getDate().toString();

  return [day, hour, minute];
};

export const normalizeDateValue = (value: string) => `${value}T00:00:00`;

export default (
  date = new Date(),
  startTime: string,
  accTimezoneOffset: number,
  accTimezone: string
) => {
  if (typeof startTime === 'object') {
    const startTimeFormatted = new Date(startTime);
    const startTimeWithCustomOffset = new Date(startTimeFormatted.getTime() - accTimezoneOffset);
    startTimeWithCustomOffset.setDate(date.getDate());

    return shiftZonedTime(startTimeWithCustomOffset, accTimezone);
  } else {
    const localDate = new Date();
    const [localHour, localMinute] = startTime.split(':');
    localDate.setHours(Number(localHour), Number(localMinute));
    localDate.setDate(date.getDate());
    const startTimeWithCustomOffset = new Date(Number(localDate.getTime()) - accTimezoneOffset);

    return shiftZonedTime(startTimeWithCustomOffset, accTimezone);
  }
};
